<div *ngIf="!loading" class="company-connectivity-details-main">
  <div class="company-connectivity-details-main__title">
    <div class="vox-heading-2">
      <i class="icon-small-arrow-left"
        [routerLink]="['../']"
        [ngbTooltip]="'company.connectivity.details.back-to-list' | translate"
        style="cursor: pointer;">
      </i>
      <span *ngIf="connection">
        {{ 'company.connectivity.details.title' | translate:
          {
            type: connection.type,
            street: connection.address.building  | titlecase,
            number: connection.address.number  | titlecase,
            province: connection.address.province  | titlecase
          }
        }}
      </span>
      <div *ngIf="!connection || !company" class="vox-inline-message vox-inline-message_light-grey">
        <div>
          <i class="icon-small-alert"></i>
          <span translate>company.connectivity.details.missing</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="connection && company" class="company-connectivity-details-main__container">
    <div ngbDropdown class="vox-dropdown dropdown">
      <button class="vox-btn btn btn-outline-secondary vox-text-field" ngbDropdownToggle>
        <span><i [ngClass]="TAB_ICONS[currentTab]"></i>{{('company.connectivity.details.tabs.' + currentTab) |
          translate }}</span>
      </button>
      <div ngbDropdownMenu class="dropdown-menu">
        <button [routerLink]="['overview']" class="dropdown-item" ngbDropdownItem (click)="switchTab('overview')">
          <i class="icon-small-telephone"></i>
          <span translate>company.connectivity.details.tabs.overview</span>
        </button>
        <button [routerLink]="['equipment']" class="dropdown-item" ngbDropdownItem (click)="switchTab('equipment')">
          <i class="icon-small-template"></i>
          <span translate>company.connectivity.details.tabs.equipment</span>
        </button>
      </div>
    </div>
    <ul ngbNav #nav="ngbNav" [activeId]="currentTab" class="nav-pills" orientation="vertical">
      <li ngbNavItem="overview">
        <a ngbNavLink [routerLink]="['overview']">
          <i class="icon-small-info"></i>
          <span translate>company.connectivity.details.tabs.overview</span>
        </a>
        <ng-template ngbNavContent>
          <router-outlet></router-outlet>
        </ng-template>
      </li>
      <li ngbNavItem="equipment">
        <a ngbNavLink [routerLink]="['equipment']">
          <i class="icon-big-phone"></i>
          <span translate>company.connectivity.details.tabs.equipment</span>
        </a>
        <ng-template ngbNavContent>
          <router-outlet></router-outlet>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="company-connectivity-details-main__tab-container"></div>
  </div>
</div>
<div *ngIf="loading">
  <ngx-skeleton-loader [theme]="{'height': '347px', 'margin-bottom': 0, 'margin-top': '5px'}"></ngx-skeleton-loader>
</div>
